// Shared opt-out helpers. Import `isConsumerOptedOut` anywhere else in the app
// (e.g. before initializing advertising/retargeting tags) to gate tracking.
export const COOKIE_NAME = 'ipacket_optout'
const BIDR_BASE_URL = 'https://cnv.event.prod.bidr.io/log/cnv'
const ADDURO_BUZZ_KEY = 'brstmedia'
const ADDURO_ACCOUNT_ID = '3'
const OPT_OUT_PIXEL_URL =
  `${BIDR_BASE_URL}?tag_id=286&buzz_key=${ADDURO_BUZZ_KEY}&segment_key=brstmedia-628&account_id=${ADDURO_ACCOUNT_ID}`
function adduroCachebuster() {
  return Math.floor(Math.random() * 10000000000)
}
// Production VDP retargeting pixel (Beeswax/Bidr). VIN is passed as `value`;
// `ord` must be a runtime cachebuster per Bidr conversion tag requirements.
export function buildAdduroVdpPixelUrl(vin) {
  const params = new URLSearchParams({
    tag_id: '184',
    buzz_key: ADDURO_BUZZ_KEY,
    value: vin,
    segment_key: '',
    account_id: ADDURO_ACCOUNT_ID,
    ord: String(adduroCachebuster()),
  })
  return `${BIDR_BASE_URL}?${params.toString()}`
}
export function fireAdduroRetargetingPixel(vin) {
  const img = document.createElement('img')
  img.width = 0
  img.height = 0
  img.src = buildAdduroVdpPixelUrl(vin)
  document.body.appendChild(img)
}
// True when the opt-out cookie is present.
export function isConsumerOptedOut() {
  return document.cookie
    .split('; ')
    .some((entry) => entry.startsWith(`${COOKIE_NAME}=`))
}
// Persist the opt-out for one year, readable across the whole app (path=/).
export function setConsumerOptOut() {
  const oneYearInSeconds = 60 * 60 * 24 * 365
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${COOKIE_NAME}=true; path=/; max-age=${oneYearInSeconds}; SameSite=Lax${secure}`
}
// Remove the opt-out cookie.
export function clearConsumerOptOut() {
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax${secure}`
}
// Fire the conversion endpoint as a GET. An Image is used so the cross-origin
// request goes out without a CORS preflight. `done` runs once the request has
// resolved (or after a short fallback) so a following page reload does not
// cancel the request before it leaves the browser.
export function fireOptOutPixel(done) {
  let finished = false
  const finish = () => {
    if (finished) return
    finished = true
    if (typeof done === 'function') done()
  }
  const img = new Image()
  img.onload = finish
  img.onerror = finish
  img.src = OPT_OUT_PIXEL_URL
  // Fallback in case the pixel is blocked and neither handler fires.
  setTimeout(finish, 1000)
}

// Send the GA4 opt-out event. event_callback lets the event flush before a
// reload; the setTimeout is a safety net since the callback can be flaky.
// No-ops cleanly if gtag has not loaded.
export function sendOptOutGtagEvent(done) {
  let finished = false
  const finish = () => {
    if (finished) return
    finished = true
    if (typeof done === 'function') done()
  }

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'ipacket_consumer_opt_out', {
      event_callback: finish,
      event_timeout: 1000,
    })
    setTimeout(finish, 1000)
  } else {
    finish()
  }
}

// Fire both the conversion pixel and the GA4 event on opt-out, then run `done`
// once both have settled (or timed out) so the reload does not cut them off.
export function fireOptOutTracking(done) {
  let pending = 2
  let settled = false
  const settle = () => {
    pending -= 1
    if (pending <= 0 && !settled) {
      settled = true
      if (typeof done === 'function') done()
    }
  }

  fireOptOutPixel(settle)
  sendOptOutGtagEvent(settle)
}
